import { Route, Routes } from "react-router"
import { Hero, Navbar, Projects } from "./components"
import { AboutPage, BlogDetails, BlogPage, ContactPage, NewsDetail, ProjectDetail, ServicesPage } from "./pages"
import NewsPage from "./pages/NewsPage/NewsPage"


const App = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/biz-haqimizda" element={<AboutPage />} />
        <Route path="/loyihalarmiz" element={<Projects />} />
        <Route path="/loyihalarmiz/:slug" element={<ProjectDetail />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogDetails />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/:slug" element={<NewsDetail />} />
        <Route path="/boglanish" element={<ContactPage />} />
        <Route path="/xizmatlar" element={<ServicesPage />} />
      </Routes>
    </>
  )
}

export default App